import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '@/lib/track';

// Public-site routes only — the internal CRM and /admin are never tracked.
const PUBLIC_EXACT = new Set(['/', '/services', '/services/pharma-bd-retainer', '/partnering', '/for-pharma', '/for-biotech',
  '/out-licensor-deck', '/in-licensor-deck', '/case-studies', '/about', '/platform', '/apply', '/pitch', '/login', '/data-room-welcome']);
const PUBLIC_PREFIXES = ['/status/', '/matches/', '/il-status/', '/engagement-status/', '/shared/mapping/', '/dataroom/'];

export const isPublicPath = (p) => PUBLIC_EXACT.has(p) || PUBLIC_PREFIXES.some(pre => p.startsWith(pre));

export const RouteTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (isPublicPath(pathname)) track('pageview', pathname);
  }, [pathname]);
  return null;
};
